import { Offering, OfferingDividend } from '@arrived/models';

export const getHistoricalReturnRange = (
  offering: Offering,
  equity: { lower?: number; upper?: number },
  offeringDividends?: OfferingDividend[]
) => {
  const minDividend =
    offering.projectedAnnualDividendYield && offeringDividends?.[0]
      ? Math.min(offering.projectedAnnualDividendYield, offeringDividends[0].annualizedDividendPercent)
      : offeringDividends?.[0]?.annualizedDividendPercent ?? offering.projectedAnnualDividendYield ?? 0;

  const maxDividend =
    offering.projectedAnnualDividendYield && offeringDividends?.[0]
      ? Math.max(offering.projectedAnnualDividendYield, offeringDividends[0].annualizedDividendPercent)
      : offeringDividends?.[0]?.annualizedDividendPercent ?? offering.projectedAnnualDividendYield ?? 0;
  return {
    total_historical_return_min: minDividend + (equity.lower ?? 0),
    total_historical_return_max: maxDividend + (equity.upper ?? 0),
  };
};
